import { IStrings } from 'localization/IStrings';
import { QuickFilter } from '../QuickFilter';

export const createQuickFilterRecord = (strings: IStrings): Record<QuickFilter, string> => {
	return {
		all: strings.all,
		notPaid: strings.notWhat(strings.paidOut),
	};
};
